import { render, staticRenderFns } from "./SearchRecipients.vue?vue&type=template&id=3e6ec40e"
import script from "./SearchRecipients.vue?vue&type=script&lang=js"
export * from "./SearchRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports